/**
 * Returns whether a dataType can be considered numeric
 *
 * @param {String} dataType
 * 		a valid DataType
 * @return {boolean} true if dataType is number, currency, or percent
 */

import DataType from 'scoreboard/datasets/model/data-type'
const { NUMBER, PERCENT, CURRENCY } = DataType

function isNumericDataType(dataType) {
	return dataType === NUMBER || dataType === PERCENT ||
		dataType === CURRENCY
}

export default isNumericDataType

isNumericDataType.__filename__ = 'components/is-numeric-data-type.js'
